import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import deLocale from 'i18n-iso-countries/langs/de.json';

import { ISelectValue } from 'interfaces/Data/SelectValue.interface';
import { IOptionGroup } from 'components/Modals/AddEditModal/ModalSection/fields/SelectField/SelectField.types';

interface ICountryListReturn {
  countriesList: ISelectValue[];
  countriesOptionGroups: IOptionGroup[];
}

const excludedCountries: string[] = ['XK'];

export const useCountryList = (filtered = true): ICountryListReturn => {
  const { i18n, t } = useTranslation();

  const currentLanguage = i18n.languages[0];

  if (currentLanguage === 'de') {
    countries.registerLocale(deLocale);
  } else {
    countries.registerLocale(enLocale);
  }
  const countriesList = countries.getNames(currentLanguage || 'en', {
    select: 'official',
  });

  const countriesListSelectValues = useMemo((): ISelectValue[] => {
    if (filtered) {
      return Object.keys(countriesList)
        .filter((countryCode) => !excludedCountries.includes(countryCode))
        .map((personNamedIndex) => {
          return {
            value: personNamedIndex,
            label: countriesList[personNamedIndex],
          };
        });
    }
    return Object.keys(countriesList).map((personNamedIndex) => {
      return {
        value: personNamedIndex,
        label: countriesList[personNamedIndex],
      };
    });
  }, [countriesList, filtered]);

  return {
    countriesList: countriesListSelectValues,
    countriesOptionGroups: [
      {
        label: t('countryList.preferred'),
        values: ['DE', 'AT', 'CH', 'GB', 'US', 'NL', 'BE', 'FR', 'IT', 'ES'],
      },
    ],
  };
};
